module.exports = __webpack_public_path__ + "img/photo-jg.751ffe94.png";